module.exports = __webpack_public_path__ + "img/1@2x.25e072a7.png";